import React from 'react';
import { Container, Row, Col, Navbar, Nav, Button, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// Custom CSS for unique styles not in Bootstrap
const customStyles = `
  .font-manrope { font-family: 'Manrope', sans-serif; }
  .text-gradient {
    background: linear-gradient(135deg, #3856c4 0%, #6d89fa 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .btn-primary-gradient {
    background: linear-gradient(135deg, #3856c4 0%, #6d89fa 100%);
    border: none;
    color: white;
  }
  .bg-surface { background-color: #f6fafe; }
  .hero-section { min-height: 80vh; display: flex; align-items: center; }
  .step-number { font-size: 0.75rem; font-weight: 800; color: #3856c4; letter-spacing: 0.1em; }
  .bento-card { border-radius: 1.5rem; padding: 2rem; border: none; height: 100%; transition: 0.3s; }
  .bento-card:hover { transform: translateY(-5px); box-shadow: 0 10px 20px rgba(0,0,0,0.05); }
`;

const WashAndPress = () => {
  const steps = [
    { id: "01", title: "Pre-wash inspection", desc: "Detailed mapping of stains and structural weak points." },
    { id: "02", title: "Fabric-specific sorting", desc: "Separating by weight, color, and textile composition." },
    { id: "03", title: "Premium detergents", desc: "Biodegradable, allergen-free enzymatic cleaners." },
    { id: "04", title: "Temperature control", desc: "Precision thermal regulation to prevent shrinkage." },
    { id: "05", title: "Collar/Cuff treatment", desc: "Hand-brushing zones of heavy wear." },
    { id: "06", title: "Colour-safe brightening", desc: "Oxygen-based revitalizers for vivid whites." },
    { id: "07", title: "Controlled drying", desc: "Moisture-sensor technology to avoid over-drying." },
    { id: "08", title: "Professional steam pressing", desc: "Industrial finishing for crisp, long-lasting lines." },
    { id: "09", title: "Button/Bead checks", desc: "Ensuring all fastenings are secure." },
    { id: "10", title: "Collar shaping", desc: "Insertable stays to maintain garment silhouette." },
    { id: "11", title: "QR code traceability", desc: "Track your garment's journey in real-time." },
    { id: "12", title: "Biodegradable hangers", desc: "Sustainability integrated into final presentation." },
  ];

  return (
    <div className="font-manrope bg-surface">
      <style>{customStyles}</style>
      <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" rel="stylesheet" />

      {/* Navigation */}


      {/* Hero Section */}
      <section className="hero-section pt-5 overflow-hidden">
        <Container className="pt-5">
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <span className="text-primary fw-bold text-uppercase mb-3 d-block tracking-widest">Premium Garment Care</span>
           
              <h1 className='expertise-title'>
                WASH & PRESS 
              </h1>
              <p className="fs-3 fw-medium text-secondary mb-3">Clean Through. Crisp Finish.</p>
              <p className="text-muted fs-5 mb-5 max-w-lg">
                     When a garment needs more than a press but deserves more than a quick machine cycle, Wash & Press is the complete answer. We combine our professional laundering process with hand-finished steam pressing, so what you receive back is not just clean — it is restored. Every fibre is refreshed; every line is rebuilt.              </p>
              <div className="d-flex flex-wrap gap-3">
                <Button href="https://wa.me/971545718455" className="btn-primary-gradient rounded-pill px-5 py-3 fw-bold d-flex align-items-center gap-2">
                  <span className="material-symbols-outlined">chat</span> WhatsApp Support
                </Button>
                <Button variant="success" className="rounded-pill px-5 py-3 fw-bold border-0 shadow-sm">
                  Download App
                </Button>
              </div>
            </Col>
            <Col lg={6} className="position-relative">
              <div className="rounded-4 overflow-hidden shadow-lg rotate-3" style={{ transform: 'rotate(2deg)' }}>
                <img src="https://images.unsplash.com/photo-1545173168-9f1947eebb7f?q=80&w=1000" alt="Shirts" className="img-fluid w-100" />
              </div>
              <Card className="position-absolute bottom-0 start-0 m-n3 shadow-lg border-0 rounded-4" style={{ maxWidth: '200px', transform: 'translate(-20px, 20px)' }}>
                <Card.Body>
                  <div className="d-flex align-items-center gap-2 text-primary mb-2">
                    <span className="material-symbols-outlined" style={{ fontVariationSettings: "'FILL' 1" }}>check_circle</span>
                    <span className="fw-bold small">Restored</span>
                  </div>
                  <p className="small text-muted mb-3">Fibres refreshed using pH-balanced chemistry.</p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Highlights (Bento Grid) */}
      <section className="py-5 bg-light mt-5">
        <Container className="py-5">
          <Row className="g-5">
            <Col md={4}>
              <div className="bento-card bg-white shadow-sm">
                <span className="material-symbols-outlined fs-1 text-primary mb-4">waves</span>
                <h4 className="fw-bold">Fabric-specific wash</h4>
                <p className="text-muted small">Individual treatment cycles based on weave and fibre density.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="bento-card bg-primary text-white">
                <span className="material-symbols-outlined fs-1 mb-4">precision_manufacturing</span>
                <h4 className="fw-bold">Automated dosing</h4>
                <p className="small">Precision chemical delivery for every cycle.</p>
              </div>
            </Col>
            <Col md={4}>
              <div className="bento-card bg-white shadow-sm">
                <div className="d-flex justify-content-between align-items-start">
                  <span className="material-symbols-outlined fs-1 text-primary mb-4">ink_eraser</span>
                  <span className="badge bg-info text-dark rounded-pill">METICULOUS</span>
                </div>
                <h4 className="fw-bold">Pre-treatment</h4>
                <p className="text-muted small">Targeted removal of oils and particulates.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>





  <section id="services" className="py-5 bg-light">
    <Container fluid="xl" className="py-5 text-center">
      <h2 className="display-6 fw-bold mb-2">Key Benefits</h2>
      <p style={{fontSize:"20px"}} className="expertise-title text-uppercase  small mb-5">Excellence in every fiber</p>
      <Row className="g-4">
        {[
         { title: "Fabric-specific wash and dry programs", desc: "No shrinkage, no colour loss, no fibre damage", icon: "👕" },
    { title: "Automated chemical dosing systems", desc: "Perfect chemistry on every load — no guesswork", icon: "🧪" },
    { title: "Pre-treatment on collars, cuffs & underarms", desc: "Brightest, cleanest results on your most visible areas", icon: "🧼" },
    { title: "pH-balanced professional detergents", desc: "Clothes that look newer, wash after wash", icon: "💧" },
    { title: "Steam pressing after washing", desc: "Crisp, sharp finish on a truly clean garment", icon: "💨" },
        
        ].map((benefit, idx) => (
          <Col key={idx} md={idx === 6 ? 12 : 6} lg={idx === 6 ? 4 : 4}>
            <Card className={`h-100 border-0 shadow-sm p-4 rounded-3 text-start transition-hover ${benefit.highlighted ? 'bg-primary-tint' : benefit.dark ? 'bg-primary-dark text-white' : 'bg-white'}`}>
              <Card.Body>
                <h4 className="fw-bold mb-3">{benefit.title}</h4>
                <Card.Text className={benefit.dark ? 'text-white-50' : 'text-muted'}>{benefit.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  </section>

 
      {/* What's Included */}

   
    </div>
  );
};

export default WashAndPress;